import AnimationSwitch from './AnimationSwitch';
export default AnimationSwitch;
